// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TeamsRouteImport } from './routes/teams'
import { Route as SuccessRouteImport } from './routes/success'
import { Route as StartRouteImport } from './routes/start'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MyDownloadsRouteImport } from './routes/my-downloads'
import { Route as MyCoursesRouteImport } from './routes/my-courses'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RedeemCodeRouteImport } from './routes/redeem.$code'
import { Route as MyDownloadsBasicBusinessAccountancyRouteImport } from './routes/my-downloads_.basic-business-accountancy'
import { Route as MyCoursesBasicBusinessAccountancyRouteImport } from './routes/my-courses_.basic-business-accountancy'
import { Route as AuthErrorRouteImport } from './routes/auth.error'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AccountPurchaseRouteImport } from './routes/account_.purchase'
import { Route as AccountProgressRouteImport } from './routes/account_.progress'
import { Route as AccountDetailsRouteImport } from './routes/account_.details'
import { Route as AccountContactRouteImport } from './routes/account_.contact'
import { Route as CoursesBusinessAndAccountancyBasicBusinessAccountancyRouteImport } from './routes/courses.business-and-accountancy.basic-business-accountancy'
import { Route as CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIndexRouteImport } from './routes/courses.business-and-accountancy.basic-business-accountancy_.lessons.index'
import { Route as CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIntroRouteImport } from './routes/courses.business-and-accountancy.basic-business-accountancy_.lessons.intro'
import { Route as CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsLessonIdRouteImport } from './routes/courses.business-and-accountancy.basic-business-accountancy_.lessons.$lessonId'

const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TeamsRoute = TeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => rootRouteImport
          })
const SuccessRoute = SuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const RefundsRoute = RefundsRouteImport.update({
            id: '/refunds',path: '/refunds',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MyDownloadsRoute = MyDownloadsRouteImport.update({
            id: '/my-downloads',path: '/my-downloads',getParentRoute: () => rootRouteImport
          })
const MyCoursesRoute = MyCoursesRouteImport.update({
            id: '/my-courses',path: '/my-courses',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RedeemCodeRoute = RedeemCodeRouteImport.update({
            id: '/redeem/$code',path: '/redeem/$code',getParentRoute: () => rootRouteImport
          })
const MyDownloadsBasicBusinessAccountancyRoute = MyDownloadsBasicBusinessAccountancyRouteImport.update({
            id: '/my-downloads_/basic-business-accountancy',path: '/my-downloads/basic-business-accountancy',getParentRoute: () => rootRouteImport
          })
const MyCoursesBasicBusinessAccountancyRoute = MyCoursesBasicBusinessAccountancyRouteImport.update({
            id: '/my-courses_/basic-business-accountancy',path: '/my-courses/basic-business-accountancy',getParentRoute: () => rootRouteImport
          })
const AuthErrorRoute = AuthErrorRouteImport.update({
            id: '/auth/error',path: '/auth/error',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AccountPurchaseRoute = AccountPurchaseRouteImport.update({
            id: '/account_/purchase',path: '/account/purchase',getParentRoute: () => rootRouteImport
          })
const AccountProgressRoute = AccountProgressRouteImport.update({
            id: '/account_/progress',path: '/account/progress',getParentRoute: () => rootRouteImport
          })
const AccountDetailsRoute = AccountDetailsRouteImport.update({
            id: '/account_/details',path: '/account/details',getParentRoute: () => rootRouteImport
          })
const AccountContactRoute = AccountContactRouteImport.update({
            id: '/account_/contact',path: '/account/contact',getParentRoute: () => rootRouteImport
          })
const CoursesBusinessAndAccountancyBasicBusinessAccountancyRoute = CoursesBusinessAndAccountancyBasicBusinessAccountancyRouteImport.update({
            id: '/courses/business-and-accountancy/basic-business-accountancy',path: '/courses/business-and-accountancy/basic-business-accountancy',getParentRoute: () => rootRouteImport
          })
const CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIndexRoute = CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIndexRouteImport.update({
            id: '/courses/business-and-accountancy/basic-business-accountancy_/lessons/',path: '/courses/business-and-accountancy/basic-business-accountancy/lessons/',getParentRoute: () => rootRouteImport
          })
const CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIntroRoute = CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIntroRouteImport.update({
            id: '/courses/business-and-accountancy/basic-business-accountancy_/lessons/intro',path: '/courses/business-and-accountancy/basic-business-accountancy/lessons/intro',getParentRoute: () => rootRouteImport
          })
const CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsLessonIdRoute = CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsLessonIdRouteImport.update({
            id: '/courses/business-and-accountancy/basic-business-accountancy_/lessons/$lessonId',path: '/courses/business-and-accountancy/basic-business-accountancy/lessons/$lessonId',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,MyCoursesRoute: MyCoursesRoute,MyDownloadsRoute: MyDownloadsRoute,PrivacyRoute: PrivacyRoute,RefundsRoute: RefundsRoute,SigninRoute: SigninRoute,StartRoute: StartRoute,SuccessRoute: SuccessRoute,TeamsRoute: TeamsRoute,TermsRoute: TermsRoute,WelcomeRoute: WelcomeRoute,AccountContactRoute: AccountContactRoute,AccountDetailsRoute: AccountDetailsRoute,AccountProgressRoute: AccountProgressRoute,AccountPurchaseRoute: AccountPurchaseRoute,AuthCallbackRoute: AuthCallbackRoute,AuthErrorRoute: AuthErrorRoute,MyCoursesBasicBusinessAccountancyRoute: MyCoursesBasicBusinessAccountancyRoute,MyDownloadsBasicBusinessAccountancyRoute: MyDownloadsBasicBusinessAccountancyRoute,RedeemCodeRoute: RedeemCodeRoute,CoursesBusinessAndAccountancyBasicBusinessAccountancyRoute: CoursesBusinessAndAccountancyBasicBusinessAccountancyRoute,CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsLessonIdRoute: CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsLessonIdRoute,CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIntroRoute: CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIntroRoute,CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIndexRoute: CoursesBusinessAndAccountancyBasicBusinessAccountancyLessonsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)